import Axios from 'axios';
import Env from '@/plugins/protokol/lib/Env'
import { attachApiLogger } from '@/shared/apiLogger'

const http = Axios.create({
  baseURL: Env.get('MEDIA_HOST'),
  timeout: 30000
});

http.defaults.withCredentials = true
http.interceptors.response.use((resp) => {
  return resp
}, (error) => {
  if (error.response !== undefined) {
    if (error.response.status == 401) {
      window.location = "/login"
    } else if (error.response.status == 403) {
      const message = (error.response.data && error.response.data.message) || window.vm.$t('forbiddenError');
      if (window.vm && window.vm.$bvToast) {
        window.vm.$bvToast.toast(message, {
          title: window.vm.$t('error'),
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        });
      }
      return Promise.reject(error)
    } else if (error.response.status == 429) {
      // Rate limit error - show toast notification
      if (window.vm && window.vm.$bvToast) {
        window.vm.$bvToast.toast(window.vm.$t('rateLimitExceeded'), {
          title: window.vm.$t('warning'),
          variant: 'warning',
          solid: true,
          autoHideDelay: 5000
        });
      }
      return Promise.reject(error)
    } else if (error.response.status == 200) {
      return error.response
    } else {
      return Promise.reject(error)
    }
  }
})

http.interceptors.request.use(function(config) {
  config.headers["X-Project-Uuid"] = localStorage.getItem("current_project_uuid")
  
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

attachApiLogger(http, 'Media')

export default http